module.exports = __webpack_public_path__ + "b3ca50713bd288bf2c4f6f887b112f64.svg";